import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "object-teaser" }
const _hoisted_2 = {
  class: "object-teaser-inner",
  "data-same-height": ""
}
const _hoisted_3 = { class: "object-teaser-title" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "object-teaser-meta" }
const _hoisted_6 = { class: "object-people" }
const _hoisted_7 = { class: "object-dating" }
const _hoisted_8 = {
  key: 0,
  hidden: "",
  "data-inventory-number": ""
}
const _hoisted_9 = { class: "object-teaser-image" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["srcset"]
const _hoisted_13 = ["src", "width", "height"]
const _hoisted_14 = {
  key: 1,
  class: "hidden",
  "data-caption": ""
}
const _hoisted_15 = {
  type: "button",
  class: "button-round button-group-child absolute bottom-0 left-0 mb-10px ml-10px p-2 text-black",
  "aria-pressed": "false"
}
const _hoisted_16 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_star = _resolveDirective("star")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("a", {
          href: _ctx.objectUrl,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.persist && _ctx.persist(...args)))
        }, _toDisplayString(_ctx.object.titles.map((title) => title.text)[0]), 9, _hoisted_4)
      ]),
      _createElementVNode("footer", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.uniquePeople.map((person) => person.name).join(', ')), 1),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.object.datings, (dating, key) => {
            return (_openBlock(), _createElementBlock("div", { key: key }, [
              (dating.prefix)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(dating.prefix) + " ", 1)
                  ], 64))
                : _createCommentVNode("", true),
              (dating.from)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(dating.from), 1),
                    (dating.to)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("–" + _toDisplayString(dating.to), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (dating.certainty)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(dating.certainty), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (dating.suffix)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(dating.suffix), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        (_ctx.object.inventoryNumber)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.object.inventoryNumber), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_ctx.preferredImage.preview)
          ? (_openBlock(), _createElementBlock("picture", _hoisted_11, [
              _createElementVNode("source", {
                srcset: `${_ctx.baseUrl}/${_ctx.preferredImage.preview.webp}`,
                type: "image/webp"
              }, null, 8, _hoisted_12),
              _createElementVNode("img", {
                src: `${_ctx.baseUrl}/${_ctx.preferredImage.preview.jpg}`,
                width: _ctx.preferredImage.preview.width,
                height: _ctx.preferredImage.preview.height,
                alt: "",
                class: "pointer-events-none",
                loading: "lazy"
              }, null, 8, _hoisted_13)
            ]))
          : _createCommentVNode("", true),
        (_ctx.preferredImage.caption)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.preferredImage.caption), 1))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('add_to_my_album')), 1),
          _cache[1] || (_cache[1] = _createElementVNode("svg", {
            class: "h-4 w-4",
            focusable: "false",
            "aria-hidden": "true",
            viewBox: "0 0 54 54",
            width: "16",
            height: "16"
          }, [
            _createElementVNode("path", {
              d: "M27,10.39L31.75,20L32.68,21.88L34.76,22.18L45.37,23.73L37.69,31.21L36.19,32.68L36.54,34.75L38.35,45.33L28.87,40.33L27.01,39.33L25.14,40.33L15.65,45.33L17.46,34.75L17.81,32.68L16.31,31.21L8.63,23.74L19.24,22.19L21.32,21.89L22.25,20L27,10.39M27,1.39L18.67,18.23L0,20.94L13.51,34.09L10.34,52.65L27,43.89L43.66,52.65L40.48,34.09L54,20.94L35.33,18.23L27,1.35L27,1.39Z",
              style: {"fill-rule":"nonzero"}
            }),
            _createElementVNode("path", {
              d: "M27,10.39L31.75,20L32.68,21.88L34.76,22.18L45.37,23.73L37.69,31.21L36.19,32.68L36.54,34.75L38.35,45.33L28.87,40.33L27.01,39.33L25.14,40.33L15.65,45.33L17.46,34.75L17.81,32.68L16.31,31.21L8.63,23.74L19.24,22.19L21.32,21.89L22.25,20L27,10.39",
              style: {"fill-rule":"nonzero"},
              fill: "none",
              class: "check-mark"
            })
          ], -1))
        ])), [
          [_directive_star, parseInt(_ctx.object.id, 10)]
        ])
      ])
    ])
  ]))
}